/*
* @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「单选选择框 自定义高度」
 * @modify Date:2021-2-25 15:43
 */

<template>
  <div class="cSingleBigChoice-container">
    <li
      v-for="(item, index) in selectdata"
      :key="index"
      :style="{ height: height ? height + 'rem' : '1rem' }"
      @click="handelSelect(item)"
      class="select-item"
      :class="{
        'select-noactive': !item.isActive && !noChoose,
        'select-active': item.isActive && !noChoose
      }"
      v-html="$sanitize(item.value)"
    ></li>
  </div>
</template>

<script>
export default {
  props: ['selectdata', 'height'],
  data() {
    return {
      noChoose: this.handelIsChoose()
    };
  },
  watch: {
    selectdata() {
      this.noChoose = this.handelIsChoose();
    }
  },
  methods: {
    handelSelect(item) {
      this.$emit('selectClick', item);
    },
    // 判断已进入页面是否有选择
    handelIsChoose() {
      return this.selectdata.every((item) => {
        return !item.isActive;
      });
    }
  }
};
</script>

<style lang='less' scoped>
.cSingleBigChoice-container {
  /*  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;*/
  .select-item {
    cursor: pointer;
    /*width: 47%;*/
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.16rem;
    color: var(--text-blackcolor);
    background-color: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    border-radius: 0.05rem;
    margin-bottom: 0.1rem;
    text-align: center;
    padding: 0 0.1rem;
    box-sizing: border-box;
    white-space: pre-wrap;
    font-weight: bold;
  }
  .select-noactive {
    color: var(--text-graycolor);
    border: 2px solid var(--text-graycolor);
    background-color: #fff;
  }
  .select-active {
    background-color: var(--maincolor);
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cBigChoice.vue